import { AxiosResponse } from "axios";
import { APIS, STUDENT_APIS } from "../api/apis";
import { getInitialAddressData } from "./apis/AddressAPI";
import { getInitialPersonData, Person } from "./apis/PersonAPI";
import { get, getAxiosHeaders, printPDF } from "./AxiosAPI";
import { ActionType, GuardianType, Note, PreviousSchool, Student, NoteType } from "./types";

export async function getStudentsByGradeAndSection(grade: "", section: ""): Promise<AxiosResponse> {
  console.log("In getStudentsByGradeAndSection:: grade: " + grade + " section: " + section);
  const currHeaders = getAxiosHeaders();
  console.log("Updating grade, section value in URL ");
  let url = APIS.GET_STUDENTS_FOR_GRADE_AND_SECTION.replace("grade_value", grade).replace("section_value", section);
  console.log("Final URL with grade, section and term: " + url);
  return get(url, currHeaders);
}

export function getInitialStudentData(): Student {
  return {
    name: "",
    admissionNo: "",
    gender: "",
    dob: undefined,
    placeOfBirth: "",
    religion: "",
    nationality: "",
    motherTongue: "",
    bloodGroup: "",
    externalId: undefined,
    present: getInitialAddressData(),
    permanent: { houseNo: undefined, streetRoad: "", areaLocality: "", landmark: "", city: "", state: "", pincode: undefined },
    previousSchools: [
      { name: "", fromGrade: "", toGrade: "", fromYear: undefined, toYear: undefined },
      { name: undefined, fromGrade: "", toGrade: "", fromYear: undefined, toYear: undefined },
    ],
    father: getInitialPersonData(),
    mother: getInitialPersonData(),
    guardian: getInitialPersonData(),
    notes: undefined,
    emergency: getInitialPersonData(),
    gradeName: "PRE-KG",
    sectionName: "",
    active: false,
    totalDue: undefined,
    requestFrom: "",
    permanentAddIsSameAsPresent: true,
    emergencyContactRelation: undefined,
    guardianContactRelation: undefined,
  };
}

export function removeNullAndUndefinedDeep<T>(value: T): T {
  if (Array.isArray(value)) {
    return value
      .map((item) => removeNullAndUndefinedDeep(item))
      .filter((item) => item !== null && item !== undefined) as unknown as T;
  }
  if (value !== null && typeof value === "object") {
    const result: Record<string, unknown> = {};
    Object.entries(value as Record<string, unknown>).forEach(([key, val]) => {
      if (val === null || val === undefined) return;
      result[key] = removeNullAndUndefinedDeep(val);
    });
    return result as T;
  }
  return value;
}

function createPreviousSchoolsData(formData: FormData, student: Student): PreviousSchool[] {
  let previousSchools: PreviousSchool[] = undefined;
  if (formData.get("std-grade")?.toString() !== "PRE-KG") {

    let psV1 = undefined,
      psV2 = undefined;
    if (formData.get("psch1name") !== null && formData.get("psch1name").toString().length > 0) {
      psV1 = {
        name: formData.get("psch1name") !== null ? formData.get("psch1name")?.toString() : undefined,
        fromGrade: formData.get("psch1fg")?.toString(),
        toGrade: formData.get("psch1tg")?.toString(),
        fromYear: parseInt(formData.get("psch1fy")?.toString()!),
        toYear: parseInt(formData.get("psch1ty")?.toString()!),
      };
    }

    if (formData.get("psch2name") !== null && formData.get("psch2name").toString().length > 0) {
      psV2 = {
        name: formData.get("psch2name") !== null ? formData.get("psch2name")?.toString() : undefined,
        fromGrade: formData.get("psch2fg")?.toString(),
        toGrade: formData.get("psch2tg")?.toString(),
        fromYear: parseInt(formData.get("psch2fy")?.toString()!),
        toYear: parseInt(formData.get("psch2ty")?.toString()!),
      };
    }

    if (psV1 !== undefined) {
      previousSchools = [];
      previousSchools.push(psV1);
    }

    if (psV2 !== undefined) {
      if (previousSchools === undefined) previousSchools = [];
      previousSchools.push(psV2);
    }
  }

  return previousSchools;
}
export function initializeStudent(
  formData: FormData,
  operation: string,
  requestFrom: string,
  permAddIsSameAsPresent: boolean,
  student: Student
): Student {
  console.log("in instd" + operation);

  let previousSchoolValue = createPreviousSchoolsData(formData, student);

  let presetnAddress = {
    houseNo: formData.get("pr-a-h")?.toString()!,
    streetRoad: formData.get("pr-a-s")?.toString()!,
    areaLocality: formData.get("pr-a-a")?.toString()!,
    landmark: formData.get("pr-a-l")?.toString()!,
    city: formData.get("pr-a-c")?.toString()!,
    state: formData.get("pr-a-st")?.toString()!,
    pincode: Number.parseInt(formData.get("pr-a-pin").toString()),
  };

  let permanentAddress = null;
  if (formData.get("permanent-address-is-same-as-present") === null) {
    permanentAddress = {
      houseNo: formData.get("prahno")?.toString(),
      streetRoad: formData.get("pras")?.toString(),
      areaLocality: formData.get("praa")?.toString(),
      landmark: formData.get("pral")?.toString(),
      city: formData.get("prac")?.toString(),
      state: formData.get("prast")?.toString(),
      pincode: Number.parseInt(formData.get("prapin").toString()),
    };
  } else permanentAddress = presetnAddress;

  const fatherValue: Person = {
    name: formData.get("f-name")?.toString()!,
    externalId: formData.get("f-aadhaarNo") !== null ? parseInt(formData.get("f-aadhaarNo")?.toString()!) : undefined,
    dob: formData.get("f-dob") !== null ? formData.get("f-dob")?.toString() : null,
    qualification: formData.get("f-qualification") !== null ? formData.get("f-qualification")?.toString() : "",
    occupation: formData.get("f-occupation") !== null ? formData.get("f-occupation")?.toString() : "",
    monthlyIncome: formData.get("f-m-income") !== null ? parseInt(formData.get("f-m-income")?.toString()!) : undefined,
    mobileNo: formData.get("f-mobile") !== null ? parseInt(formData.get("f-mobile")?.toString()!) : undefined,
    email: formData.get("f-email") !== null ? formData.get("f-email")?.toString() : "",
  };

  const motherValue: Person = {
    newAadhaarNumber: undefined,
    name: formData.get("m-name")?.toString()!,
    externalId: formData.get("m-aadhaarNo") !== null ? parseInt(formData.get("m-aadhaarNo")?.toString()!) : undefined,
    dob: formData.get("m-dob") !== null ? formData.get("m-dob")?.toString() : null,
    qualification: formData.get("m-qualification") !== null ? formData.get("m-qualification")?.toString() : "",
    occupation: formData.get("m-occupation") !== null ? formData.get("m-occupation")?.toString() : "",
    monthlyIncome: formData.get("m-m-income") !== null ? parseInt(formData.get("m-m-income")?.toString()!) : undefined,
    mobileNo: formData.get("m-mobile") !== null ? parseInt(formData.get("m-mobile")?.toString()!) : undefined,
    email: formData.get("m-email") !== null ? formData.get("m-email")?.toString() : ""
  };
  let guardianValue = null;
  if (formData.get("guardian").toString() === GuardianType.FATHER) {
    guardianValue = fatherValue;
  } else if (formData.get("guardian").toString() === GuardianType.MOTHER) {
    guardianValue = motherValue;
  } else {
    guardianValue = {
      newAadhaarNumber: undefined,
      name: formData.get("g-name")?.toString()!,
      externalId: formData.get("g-aadhaarNo") !== null ? parseInt(formData.get("g-aadhaarNo")?.toString()!) : undefined,
      dob: formData.get("g-dob") !== null ? formData.get("g-dob")?.toString() : null,
      qualification: formData.get("g-qualification") !== null ? formData.get("g-qualification")?.toString() : "",
      occupation: formData.get("g-occupation") !== null ? formData.get("g-occupation")?.toString() : "",
      monthlyIncome: formData.get("g-m-income") !== null ? parseInt(formData.get("m-m-income")?.toString()!) : undefined,
      mobileNo: formData.get("g-mobile") !== null ? parseInt(formData.get("g-mobile")?.toString()!) : undefined,
      email: formData.get("g-email") !== null ? formData.get("g-email")?.toString() : ""
    };
  }

  let notes = getNotes(formData);

  let stdObject: Student = {
    name: student.name,
    admissionNo: formData.get("")?.toString(),
    gender: formData.get("gender")?.toString()!,
    dob: formData.get("dob")?.toString()!,
    placeOfBirth: formData.get("placeOfBirth")?.toString(),
    religion: formData.get("religion")?.toString(),
    nationality: formData.get("nationality")?.toString(),
    motherTongue: formData.get("mTongue")?.toString(),
    bloodGroup: formData.get("bGroup")?.toString(),
    externalId: formData.get("aadhaarNo") !== null ? parseInt(formData.get("aadhaarNo")?.toString()!) : undefined,
    present: presetnAddress,
    permanent: permanentAddress,
    previousSchools: previousSchoolValue,
    father: fatherValue,
    mother: motherValue,
    guardian: guardianValue,
    notes: notes,
    emergency: {
      newAadhaarNumber: undefined,
      name: formData.get("emg-name")?.toString()!,
      externalId: parseInt(formData.get("e-aadhaarNo")?.toString()!),
      dob: null,
      qualification: "",
      occupation: "",
      monthlyIncome: undefined,
      mobileNo: parseInt(formData.get("emg-phone")?.toString()!),
      email: ""
    },
    gradeName: undefined,
    sectionName: undefined,
    active: operation === ActionType.UPDATE,
    totalDue: 0,
    requestFrom: requestFrom,
    permanentAddIsSameAsPresent: permAddIsSameAsPresent,
    emergencyContactRelation: "Father",
    guardianContactRelation: "Father",
  };

  return removeNullAndUndefinedDeep(stdObject);
}

export function initializeStudentForUpdate(
  formData: FormData,
  operation: string,
  requestFrom: string,
  permAddIsSameAsPresent: boolean,
  student: Student
): Student {
  console.log("in instd" + operation);

  let previousSchoolsValue: PreviousSchool[] = createPreviousSchoolsData(formData, student);
  let stdObject: Student = {
    name: formData.get("sName")?.toString()!,
    admissionNo: student.admissionNo,
    gender: formData.get("gender")?.toString()!,
    dob: formData.get("dob")?.toString()!,
    placeOfBirth: formData.get("placeOfBirth")?.toString(),
    religion: formData.get("religion")?.toString(),
    nationality: formData.get("nationality")?.toString(),
    motherTongue: formData.get("mTongue")?.toString(),
    bloodGroup: formData.get("bGroup")?.toString(),
    externalId: formData.get("aadhaarNo") !== null ? parseInt(formData.get("aadhaarNo")?.toString()!) : undefined,
    present: {
      houseNo: formData.get("pr-a-h")?.toString()!,
      streetRoad: formData.get("pr-a-s")?.toString()!,
      areaLocality: formData.get("pr-a-a")?.toString()!,
      landmark: formData.get("pr-a-l")?.toString()!,
      city: formData.get("pr-a-c")?.toString()!,
      state: formData.get("pr-a-st")?.toString()!,
      pincode: Number.parseInt(formData.get("pr-a-pin").toString()),
    },
    permanent:
      permAddIsSameAsPresent !== true
        ? {
          houseNo: formData.get("prahno")?.toString(),
          streetRoad: formData.get("pras")?.toString(),
          areaLocality: formData.get("praa")?.toString(),
          landmark: formData.get("pral")?.toString(),
          city: formData.get("prac")?.toString(),
          state: formData.get("prast")?.toString(),
          pincode: Number.parseInt(formData.get("prapin").toString()),
        }
        : undefined,

    previousSchools: previousSchoolsValue,
    father: {
      newAadhaarNumber: undefined,
      name: formData.get("f-name")?.toString()!,
      externalId: parseInt(formData.get("f-aadhaarNo")?.toString()!),
      dob: formData.get("f-dob") !== null ? formData.get("f-dob")?.toString() : undefined,
      qualification: formData.get("f-qualification") !== null ? formData.get("f-qualification")?.toString() : "",
      occupation: formData.get("f-occupation") !== null ? formData.get("f-occupation")?.toString() : "",
      monthlyIncome: formData.get("f-m-income") !== null ? parseInt(formData.get("f-m-income")?.toString()!) : undefined,
      mobileNo: formData.get("f-mobile") !== null ? parseInt(formData.get("f-mobile")?.toString()!) : undefined,
      email: formData.get("f-email") !== null ? formData.get("f-email")?.toString() : "",
      relation: "Father",
      guardian: formData.get("guardian")?.toString()! === GuardianType.FATHER,
      emergency: false,
    },
    mother: {
      newAadhaarNumber: undefined,
      name: formData.get("m-name")?.toString()!,
      externalId: parseInt(formData.get("m-aadhaarNo")?.toString()!),
      dob: formData.get("m-dob") !== null ? formData.get("m-dob")?.toString() : undefined,
      qualification: formData.get("m-qualification") !== null ? formData.get("m-qualification")?.toString() : "",
      occupation: formData.get("m-occupation") !== null ? formData.get("m-occupation")?.toString() : "",
      monthlyIncome: formData.get("m-m-income") !== null ? parseInt(formData.get("m-m-income")?.toString()!) : undefined,
      mobileNo: formData.get("m-mobile") !== null ? parseInt(formData.get("m-mobile")?.toString()!) : undefined,
      email: formData.get("m-email") !== null ? formData.get("m-email")?.toString() : "",
      relation: "Mother",
      guardian: formData.get("guardian")?.toString()! === GuardianType.MOTHER,
      emergency: false,
    },
    guardian:
      formData.get("guardian")?.toString() === GuardianType.OTHER
        ? {
          newAadhaarNumber: undefined,
          name: formData.get("g-name")?.toString()!,
          externalId: parseInt(formData.get("g-aadhaarNo")?.toString()!),
          dob: formData.get("g-dob") !== null ? formData.get("g-dob")?.toString() : undefined,
          qualification: formData.get("g-qualification") !== null ? formData.get("g-qualification")?.toString() : "",
          occupation: formData.get("g-occupation") !== null ? formData.get("g-occupation")?.toString() : "",
          monthlyIncome: formData.get("g-m-income") !== null ? parseInt(formData.get("m-m-income")?.toString()!) : undefined,
          mobileNo: formData.get("g-mobile") !== null ? parseInt(formData.get("g-mobile")?.toString()!) : undefined,
          email: formData.get("g-email") !== null ? formData.get("g-email")?.toString() : "",
          relation: formData.get("g-relation") !== null ? formData.get("g-relation")?.toString() : "",
          guardian: true,
          emergency: false,
        }
        : {
          newAadhaarNumber: undefined,
          name: student.guardian.name,
          externalId: student.guardian.externalId,
          dob: student.guardian.dob,
          qualification: student.guardian.qualification,
          occupation: student.guardian.occupation,
          monthlyIncome: student.guardian.monthlyIncome,
          mobileNo: student.guardian.mobileNo,
          email: student.guardian.email,
          relation: student.guardian.relation,
          guardian: true,
          emergency: false,
        },
    notes: undefined,
    emergency: {
      newAadhaarNumber: undefined,
      name: formData.get("emg-name")?.toString()!,
      externalId: parseInt(formData.get("e-aadhaarNo")?.toString()!),
      dob: undefined,
      qualification: "",
      occupation: "",
      monthlyIncome: undefined,
      mobileNo: parseInt(formData.get("emg-phone")?.toString()!),
      email: "",
      relation: formData.get("emg-relation")?.toString()!,
      guardian: false,
      emergency: false,
    },
    gradeName: formData.get("std-grade")?.toString(),
    sectionName: formData.get("std-section")?.toString(),
    active: student.active,
    totalDue: 0,
    requestFrom: requestFrom,
    permanentAddIsSameAsPresent: permAddIsSameAsPresent,
    emergencyContactRelation: "Father",
    guardianContactRelation: "Father",
  };

  if (formData.get("psch2name") !== null && formData.get("psch2name") !== undefined && formData.get("psch2name").toString().trim().length > 0) {
    stdObject.previousSchools.push();
  }

  if (permAddIsSameAsPresent) {
    stdObject.permanent = stdObject.present;
  }
  if (stdObject.father.guardian) {
    stdObject.guardian = stdObject.father;
  } else if (stdObject.mother.guardian) {
    stdObject.guardian = stdObject.mother;
  }

  return stdObject;
}

export function getNotes(formData: FormData): Note[] {
  let notes: Note[] = [];
  let medicalNote = undefined,
    learningNote = undefined,
    regularMedicationNote = undefined;

  if (formData.get("std-medical-disability-select") === "Yes") {
    let comment = formData.get("std-medical-disability-text").toString();
    medicalNote = { type: NoteType.MEDICAL_DISABILITY, comment: comment };
  }

  if (formData.get("std-learn-disability-select") === "Yes") {
    let comment = formData.get("std-learn-disability-text").toString();
    learningNote = { type: NoteType.LEARNING_DISABILITY, comment: comment };
  }

  if (formData.get("r-medication-text") !== undefined && formData.get("r-medication-text").valueOf().toString().length > 0) {
    let comment = formData.get("r-medication-text").valueOf().toString();
    regularMedicationNote = { type: NoteType.REGULAR_MEDICATION, comment: comment };
  }

  if (medicalNote !== undefined) notes.push(medicalNote);
  if (learningNote !== undefined) notes.push(learningNote);
  if (regularMedicationNote !== undefined) notes.push(regularMedicationNote);

  if (medicalNote === undefined && learningNote === undefined && regularMedicationNote === undefined) return undefined;
  else return notes;
}

export const printStudentAdmissionForm = (admissionNo: string) => {
  console.log(">>> printReceipt");

  let url = STUDENT_APIS.PRINT_STUDENT_ADMISSION_FORM;
  console.log("URL to generate fee receipt: " + url);
  let headers = getAxiosHeaders();
  headers.set("admissionNo", admissionNo);
  printPDF(url, headers);
};
